import { FC } from "react";

export const RsvpFormStatus: FC = () => {
  return (
    <div className="form_status_message">
      <div className="alert alert-success alert-dismissible fade show" role="alert">
        Form successfully submitted! :)
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    </div>
  );
};
